module.exports = __webpack_public_path__ + "img/backline_once.0880c1e5.gif";